// extracted by mini-css-extract-plugin
module.exports = {"roomAvailability":"styles_roomAvailability__zRt_k"};